import { PerformanceCase } from './types';

export function localDateTime(value: number): string {
  const date = new Date(value);
  return new Date(value - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}
export function reportRange(fromValue: string, toValue: string, now = Date.now()) {
  const from = new Date(fromValue).getTime();
  const to = new Date(toValue).getTime();
  if (!Number.isFinite(from) || !Number.isFinite(to) || to <= from || to - from > 86400000 || to > now + 5000) return null;
  return { from: new Date(from).toISOString(), to: new Date(to).toISOString() };
}
export interface SampleFilters {
  advisor: string;
  team: string;
  origin: string;
}
const key = (value: string | number | null) => (value === null ? 'unassigned' : String(value));
export function filterSample(cases: PerformanceCase[], filters: SampleFilters) {
  return cases.filter(
    (row) =>
      (!filters.advisor || key(row.agentUserId) === filters.advisor) &&
      (!filters.team || key(row.teamId) === filters.team) &&
      (!filters.origin || key(row.origin) === filters.origin),
  );
}
export function groupSample(cases: PerformanceCase[], by: 'advisor' | 'team') {
  const groups = new Map<
    string,
    {
      id: string;
      name: string | null;
      cases: number;
      needsAgent: number;
      messageLinks: number;
      stateObservations: number;
    }
  >();
  for (const row of cases) {
    const id = key(by === 'advisor' ? row.agentUserId : row.teamId);
    const item = groups.get(id) ?? {
      id,
      name: by === 'advisor' ? row.agentName : row.teamName,
      cases: 0,
      needsAgent: 0,
      messageLinks: 0,
      stateObservations: 0,
    };
    item.cases++;
    if (row.status === 'needsAgentAction') item.needsAgent++;
    item.messageLinks += row.messageLinks;
    item.stateObservations += row.stateObservations;
    groups.set(id, item);
  }
  return [...groups.values()].sort((a, b) => (a.name ?? a.id).localeCompare(b.name ?? b.id));
}
